import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Song } from '../../models/song';
import { SongService } from '../../services/song.service';
import { ComposerService } from '../../services/composer.service'; // Import ComposerService
import { Composer } from '../../models/composer'; // Import Composer model

@Component({
  selector: 'app-song-dialog',
  templateUrl: './song-dialog.component.html',
  styleUrls: ['./song-dialog.component.scss'], // Updated to .scss
  standalone: false
})
export class SongDialogComponent implements OnInit {
  editForm: FormGroup;
  viewMode: boolean;
  composerFullName: string = ''; // Store the composer's full name
  composers: Composer[] = []; // List of all composers for the lookup

  constructor(
    private fb: FormBuilder,
    private songService: SongService,
    private composerService: ComposerService, // Inject ComposerService
    private dialogRef: MatDialogRef<SongDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { song: Song | null; viewMode: boolean }
  ) {
    this.viewMode = data.viewMode;
    this.editForm = this.fb.group({
      id: [data.song?.id || 0],
  name: [data.song?.name || '', Validators.required],
      composerId: [data.song?.composerId || null],
      genre: [data.song?.genre || ''],
      genreGroup: [data.song?.genreGroup || ''],
      voicing: [data.song?.voicing || ''],
      instruments: [data.song?.instruments || ''],
      language: [data.song?.language || ''],
  year: [data.song?.year ?? null],
  resourceFolder: [data.song?.resourceFolder || ''],
      comments: [data.song?.comments || '']
    });

    if (data.song?.composerId) {
      this.loadComposerFullName(data.song.composerId); // Load the composer's full name
    }
  }

  ngOnInit(): void {
    this.loadComposers(); // Load the list of all composers for the lookup
  }

  private loadComposerFullName(composerId: number): void {
    this.composerService.getComposers().subscribe({
      next: (composers) => {
        const composer = composers.find(c => c.id === composerId); // Find the composer by ID
        this.composerFullName = composer ? composer.fullName : 'Unknown'; // Set the composer's full name or 'Unknown'
      },
      error: (error) => {
        console.error('Error loading composers:', error);
      }
    });
  }

  private loadComposers(): void {
    this.composerService.getComposers().subscribe({
      next: (composers) => {
        this.composers = composers; // Populate the list of composers
      },
      error: (error) => {
        console.error('Error loading composers:', error);
      }
    });
  }

  saveChanges(): void {
    if (this.editForm.valid) {
      const raw = this.editForm.value as any;
      const payload: any = { ...raw };
      // Normalize optional numeric fields
      payload.year = raw.year === '' || raw.year === undefined || raw.year === null ? null : Number(raw.year);
      payload.composerId = raw.composerId === '' || raw.composerId === undefined || raw.composerId === null
        ? null
        : Number(raw.composerId);
      // Do not send id when creating
      if (!payload.id || payload.id === 0) {
        delete payload.id;
        this.songService.createSong(payload).subscribe({
          next: () => this.dialogRef.close(true),
          error: (err) => {
            console.error('Failed to create song', err);
            alert('Failed to create song. Please check required fields and try again.');
          }
        });
      } else {
        this.songService.updateSong(payload.id, payload).subscribe({
          next: () => this.dialogRef.close(true),
          error: (err) => {
            console.error('Failed to update song', err);
            alert('Failed to update song. Please check the values and try again.');
          }
        });
      }
    }
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}
